export const HttpStatusCodes = {
    OK: 200,
    Created: 201,
    NoContent: 204,
    MovedPermanently: 301,
    Found: 302,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    Forbidden: 403,
    NotFound: 404,
    Conflict: 409,
    Gone: 410,
    AuthenticationTimeout: 419,
    UnprocessableEntity: 422,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
};
